module.exports = __webpack_public_path__ + "static/media/country_aq.6b55e9e2.webp";